import type { DragEvent, MouseEvent } from 'react'
import { Camera, Upload } from 'lucide-react'
import type { UploadProgress } from '../lib/hooks'

export interface EmptyAlbumDropzoneProps {
  isDropzoneActive: boolean
  onDropzoneDragOver: (e: DragEvent) => void
  onDropzoneDragLeave: (e: DragEvent) => void
  onDropzoneDrop: (e: DragEvent) => void
  onDropzoneClick: () => void
  onAddPhotos: () => void
  uploadProgress: UploadProgress
}

// Presentational only: the "This story is waiting to be told" empty-album
// dropzone -- container, icon, copy, the upload button whose label tracks
// `uploadProgress.status`, and the progress bar. Every handler arrives as a
// prop; upload state lives in album-list.tsx's hooks (SOL-150).
export default function EmptyAlbumDropzone({
  isDropzoneActive,
  onDropzoneDragOver,
  onDropzoneDragLeave,
  onDropzoneDrop,
  onDropzoneClick,
  onAddPhotos,
  uploadProgress,
}: EmptyAlbumDropzoneProps) {
  return (
    <div
      className={`album-list-empty ${isDropzoneActive ? 'album-list-empty--dragover' : ''}`}
      onDragOver={onDropzoneDragOver}
      onDragLeave={onDropzoneDragLeave}
      onDrop={onDropzoneDrop}
      onClick={onDropzoneClick}
    >
      <Camera className="empty-icon" size={64} strokeWidth={1.5} />
      <h3>This story is waiting to be told</h3>
      <p>Drop your photos here to bring these memories to life</p>
      <button
        className="add-photos-btn"
        onClick={(e: MouseEvent) => { e.stopPropagation(); onAddPhotos(); }}
        disabled={uploadProgress.status !== 'idle' && uploadProgress.status !== 'done' && uploadProgress.status !== 'error'}
      >
        <Upload size={18} />
        <span>
          {uploadProgress.status === 'initializing' && 'Preparing...'}
          {uploadProgress.status === 'uploading' && `Uploading ${uploadProgress.completedFiles + 1}/${uploadProgress.totalFiles}...`}
          {uploadProgress.status === 'completing' && 'Finishing...'}
          {(uploadProgress.status === 'idle' || uploadProgress.status === 'done' || uploadProgress.status === 'error') && 'Choose Photos'}
        </span>
      </button>
      {uploadProgress.status === 'uploading' && (
        <div className="upload-progress">
          <div className="upload-progress-bar" style={{ width: `${uploadProgress.overallProgress}%` }} />
        </div>
      )}
    </div>
  )
}
